import React, { PureComponent, useState, Component } from 'react';
import { Layout, Row, Col, Popover, Button, Modal } from 'antd';
import { ButtonRadius } from 'src/components/elements/Button';
import { withRouter, Link } from 'react-router-dom';
import styles from './styles.module.css';
import {
  DashboardOutlined,
  LineChartOutlined,
  UserOutlined,
  ToolOutlined,
  SettingOutlined,
  AntDesignOutlined,
  PoweroffOutlined
} from '@ant-design/icons';
import { getUser } from 'src/redux/selectors';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Cookies } from 'react-cookie';
import { userInfo } from 'os';
import SignaturePad from 'react-signature-canvas';
import ReactDOM from 'react-dom';
const StyledLink = styled(Link)`
  color: #fff !important;
  font-size: 15px;
  :hover {
    text-decoration: none !important;
  }
  .anticon svg {
    display: inline-block;
    font-size: 20px !important;
    color: white !important;
  }
`;
const StyledModal = styled(Modal)`
  .ant-modal-footer {
    display: none;
  }
`;

class App extends Component {
  state = { trimmedDataURL: null };
  sigPad = {};
  clear = () => {
    this.sigPad.clear();
  };
  trim = () => {
    this.setState({
      trimmedDataURL: this.sigPad.getTrimmedCanvas().toDataURL('image/png')
    });
  };
  render() {
    let { trimmedDataURL } = this.state;
    return (
      <div className={styles.container}>
        <div className={styles.sigContainer}>
          <SignaturePad
            canvasProps={{ className: styles.sigPad }}
            ref={ref => {
              this.sigPad = ref;
            }}
          />
        </div>
        <div>
          <button className={styles.buttons} onClick={this.clear}>
            Clear
          </button>
        </div>
      </div>
    );
  }
}

const Signature = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <>
      <Col span={4} style={{ display: 'flex' }}>
        <div
          onClick={showModal}
          style={{
            margin: 'auto',
            background: '#EC8144',
            borderRadius: '50%',
            width: 60,
            height: 60,
            bottom: 20,
            position: 'relative',
            display: 'flex',
            border: '4px solid white'
          }}
        >
          <AntDesignOutlined
            style={{
              margin: 'auto',
              color: 'white',
              fontSize: 20
            }}
          />
        </div>
      </Col>

      <StyledModal
        title={<p>Add Signature</p>}
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <App />

        <Button
          style={{
            marginTop: '1em',
            height: '3em',
            width: '100%',
            fontSize: 14,
            border: 'none',
            fontFamily: 'Open Sans',
            textShadow: 'none',
            backgroundColor: '#EC8144'
          }}
          type="primary"
          onClick={handleCancel}
          size="large"
          block
        >
          Submit Signature
        </Button>
      </StyledModal>
    </>
  );
};
const getInitials = function(sName) {
  var names = sName.split(' '),
    initials = names[0].substring(0, 1).toUpperCase();

  if (names.length > 1) {
    initials += names[names.length - 1].substring(0, 1).toUpperCase();
  }
  return initials;
};
const signOut = s => {
  if (window.cordova) {
    window.FirebasePlugin.getToken(
      token => {
        window.pubnub.push.deleteDevice(
          {
            device: token,
            pushGateway: 'gcm' // apns, gcm, mpns
          },
          function(status) {
            if (status.error) {
              console.log('operation failed w/ error:', status);
            }
          }
        );
      },
      error => {
        console.error(error);
      }
    );
  }

  const cookies = new Cookies();
  cookies.remove('token');
  cookies.remove('basic');
  localStorage.clear();
  window.location.reload();
};
export class ResFooter extends PureComponent {
  state = {
    dash: true,
    shift: false,
    profile: false,
    tools: false
  };

  onDashActive = dash => {
    this.setState({ dash });
    this.setState({ shift: false });
    this.setState({ profile: false });
    this.setState({ tools: false });
  };
  onToolsActive = tools => {
    this.setState({ tools });
    this.setState({ shift: false });
    this.setState({ dash: false });
    this.setState({ profile: false });
  };
  onShiftActive = shift => {
    this.setState({ shift });
    this.setState({ tools: false });
    this.setState({ dash: false });
    this.setState({ profile: false });
  };
  onProfileActive = profile => {
    this.setState({ profile });
    this.setState({ tools: false });
    this.setState({ dash: false });
    this.setState({ shift: false });
  };
  render() {
    if (window.innerWidth <= 1100) {
      window.isPhone = true;
    } else {
      window.isPhone = false;
    }
    return (
      <Layout.Footer
        style={{
          zIndex: 5,
          width: '100%',
          position: 'fixed',
          bottom: 0,
          background: '#003A98',
          lineHeight: '40px',
          padding: 0,
          height: '3.5em',
          boxShadow: '0px 11px 20px 0 rgba(0, 0, 0, 10)',
          display: window.isPhone ? '' : 'none'
        }}
      >
        <Row type="flex" justify="space-around" style={{}}>
          <Col span={4} style={{ display: 'flex' }}>
            <Link
              to="/user/pexunits"
              style={{ marginLeft: '1.5em', marginTop: '0.5em' }}
            >
              <div
                onClick={this.onDashActive}
                style={{
                  color: 'white',
                  margin: 'auto',
                  marginBottom: '1.2em',
                  display: 'grid',
                  cursor: 'pointer',
                  borderRadius: '0.3em',
                  backgroundColor: this.state.dash ? '#EC8144' : ''
                }}
              >
                <DashboardOutlined
                  style={{
                    margin: 'auto',
                    padding: '0.4em',
                    fontSize: 20
                  }}
                />
                {/*<span
                style={{
                  marginTop: -11,
                  fontSize: 12,
                }}
              >
                Home
              </span>*/}
              </div>
            </Link>
          </Col>
          <Col span={4} style={{ display: 'flex' }}>
            <Link
              to="/user/shiftmanager"
              style={{ margin: 'auto', marginBottom: '0.5em' }}
            >
              <div
                onClick={this.onShiftActive}
                style={{
                  color: 'white',
                  margin: 'auto',
                  marginBottom: '1.2em',
                  display: 'grid',
                  cursor: 'pointer',
                  borderRadius: '0.3em',
                  backgroundColor: this.state.shift ? '#EC8144' : ''
                }}
              >
                <LineChartOutlined
                  style={{
                    margin: 'auto',
                    padding: '0.4em',
                    fontSize: 20
                  }}
                />

                {/*<span
                style={{
                  marginTop: -11,
                  fontSize: 12,
                }}
              >
                Search
              </span>*/}
              </div>{' '}
            </Link>
          </Col>
          <Col span={4} style={{ display: 'flex' }}>
            <Link
              to="/user/pexunits"
              style={{ marginLeft: '1.5em', marginTop: '0.5em' }}
            >
              <div
                // onClick={showModal}
                onClick={this.onDashActive}
                style={{
                  margin: 'auto',
                  background: '#EC8144',
                  borderRadius: '50%',
                  width: 60,
                  height: 60,
                  bottom: 20,
                  position: 'relative',
                  display: 'flex',
                  border: '4px solid white'
                }}
              >
                <AntDesignOutlined
                  style={{
                    margin: 'auto',
                    color: 'white',
                    fontSize: 20
                  }}
                />
              </div>
            </Link>
          </Col>
          {/* <Signature /> */}
          <Col span={4} style={{ display: 'flex' }}>
            <Link
              to="/user/dashboard"
              style={{ marginLeft: '1.5em', marginTop: '0.5em' }}
            >
              <div
                onClick={this.onToolsActive}
                style={{
                  color: 'white',
                  margin: 'auto',
                  marginBottom: '1.2em',
                  display: 'grid',
                  cursor: 'pointer',
                  borderRadius: '0.3em',
                  backgroundColor: this.state.tools ? '#EC8144' : ''
                }}
              >
                <ToolOutlined
                  style={{
                    margin: 'auto',
                    padding: '0.4em',
                    fontSize: 20
                  }}
                />
                {/*<span
                style={{
                  marginTop: -11,
                  fontSize: 12,
                }}
              >
                Home
              </span>*/}
              </div>
            </Link>
          </Col>

          <Col span={4} style={{ display: 'flex' }}>
            <div
              onClick={signOut}
              style={{
                color: 'white',
                margin: 'auto',
                marginBottom: '2.3em',
                display: 'grid'
              }}
            >
              <PoweroffOutlined
                style={{
                  margin: 'auto',

                  fontSize: 20
                }}
              />
              {/*<span
                style={{
                  marginTop: -11,
                  fontSize: 12,
                }}
              >
                Profile
              </span>*/}
            </div>
          </Col>
        </Row>
      </Layout.Footer>
    );
  }
}

const mapStateToProps = state => ({
  user: getUser(state) || {}
});

export default withRouter(connect(mapStateToProps)(ResFooter));
